export default {
  // 获取设备信息
  selectMetaDevice: '/api/v1/device/selectMetaDevice'
}
